export class Classificacao {
  public classificacao?: string;
  public description?: string;
  public descriptionEn?: string;
  public descriptionDe?: string;
}
